import { execute } from 'utils/API';
import { apiEndoints, httpMethods } from 'utils/constants';
import PropTypes from 'prop-types';

const listPartners = ({ queryKey }) => {
  return execute(
    httpMethods.GET,
    queryKey[2] === '' ? apiEndoints.LIST_PARTNERS : apiEndoints.LIST_QUERIED_PARTNERS,
    { authorization: queryKey[3] },
    {
      page: queryKey[1],
      ...(queryKey[2] !== '' && { search: queryKey[2] }),
    },
    10,
  );
};

listPartners.propTypes = {
  queryKey: PropTypes.array.isRequired,
};

export { listPartners };
